import { createCustomerIfNew, sanitizePhoneNumber, } from "../../customer/index.js";
import { createSubscriptionContract } from "../mutations/createSubscriptionContract.core.js";
import Logger from "@cappelendamm/logger";
import { getSignUpSubscriptionContractData } from "./getSignUpSubscriptionContractData.js";
import { addDataFactoryIdToCustomer } from "../../customer/utils/addDataFactoryIdToCustomer.js";
import { getDataFactoryUserAdvanced, } from "@cappelendamm/user-services";
export const signUpSubscriptionContract = async (input, signUpSubscriptionContractOptions = {
    isImported: false,
    sendEmail: true,
}, { client, dataFactoryClient }, selectedBookSku, idReference) => {
    const { customer } = input;
    const isImported = !!signUpSubscriptionContractOptions.isImported;
    // Only lookup DataFactory if not imported and we have an API key
    const shouldLookupDF = !isImported && !!dataFactoryClient?.apiKey;
    let customerWithDataFactoryId = customer;
    let customerInDataFactory = undefined;
    if (shouldLookupDF) {
        try {
            const payload = {
                firstName: customer.firstName,
                lastName: customer.lastName,
                birthDate: customer.birthDate,
                addresses: [
                    customer.addresses.delivery,
                    customer.addresses.billing,
                ].filter(Boolean),
                ...(customer.phone && { phone: sanitizePhoneNumber(customer.phone) }),
            };
            customerInDataFactory = await getDataFactoryUserAdvanced(payload, dataFactoryClient);
            Logger.log(`DataFactory lookup completed for ${customer.firstName} ${customer.lastName}${customer.phone ? " (with phone)" : " (without phone)"}.`);
            customerWithDataFactoryId = addDataFactoryIdToCustomer(customer, customerInDataFactory?.personDetail?.objectIdentity);
        }
        catch (error) {
            Logger.error(`Error fetching customer from DataFactory while signing up customer${customer.phone
                ? ` with phone: ${customer.phone}`
                : " (no phone provided)"}. Skipping DF enrichment. Error:`, error);
        }
    }
    else {
        Logger.log(`[signup] Skipping DataFactory lookup (isImported=${isImported} hasDataFactoryClient=${!!dataFactoryClient})`);
    }
    const customerIdentifier = await createCustomerIfNew(customerWithDataFactoryId, { client }, idReference);
    const { contract, product } = await getSignUpSubscriptionContractData(input, signUpSubscriptionContractOptions, customerIdentifier, { client }, selectedBookSku, customerInDataFactory);
    Logger.log(`Creating new contract for product: ${product.sku}, with customerIdentifier: ${customerIdentifier}, with renew date: ${contract.status.renewAt}`);
    const contractId = await createSubscriptionContract(contract, { client });
    return {
        contractId,
        message: `Subscription ${contractId} created successfully.`,
    };
};
